import type { AppBadgeCountModeT, Task } from '@portfolio-pm/shared';
import { useEffect, useState } from 'react';
import { getAppBadgeCount, syncAppBadgeCount } from './app-badge.ts';

export function useAppBadge(tasks: Task[], mode: AppBadgeCountModeT): void {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    let timeout: number | undefined;
    const updateAtNextLocalDay = (): void => {
      const next = new Date();
      next.setHours(24, 0, 1, 0);
      timeout = window.setTimeout(() => {
        setNow(Date.now());
        updateAtNextLocalDay();
      }, next.getTime() - Date.now());
    };

    updateAtNextLocalDay();
    return () => {
      if (timeout !== undefined) window.clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    void syncAppBadgeCount(getAppBadgeCount(tasks, mode, now));
  }, [mode, now, tasks]);
}
